// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.invoices {
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-items: center;
}
.invoices h1 {
  color: #4d4d4d;
  text-align: center;
}
.invoices .invoicesHeader {
  display: flex;
  justify-content: space-between;
}
.invoices .invoicesHeader .manualEdn {
  margin-left: 10%;
  height: 15%;
}
.invoices .invoicesHeader .update {
  color: #4d4d4d;
  text-align: right;
  margin-right: 10%;
}
.invoices .invoiceTable {
  min-height: 73vh;
}
.invoices .invoiceTable #invoices {
  width: 80%;
  margin: auto;
}
.invoices .invoiceTable #invoices .invoiceData {
  text-align: center;
}
.invoices .invoiceTable table th {
  background-color: #2d53a1;
  color: #fcfcfc;
}
.invoices .invoiceTable table tr {
  background-color: #fcfcfc;
  color: #2d53a1;
  border-color: #2d53a1;
}
.invoices .invoiceTable .wasteForm {
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  align-items: center;
  width: 80%;
  margin: auto;
}
.invoices .invoiceTable .wasteForm table {
  width: 100%;
  margin: 2% auto;
  table-layout: fixed;
}
.invoices .invoiceTable .wasteForm table thead tr {
  background-color: #2d53a1;
  color: #fcfcfc;
}
.invoices .invoiceTable .wasteForm table tbody {
  background-color: #fff;
}
.invoices .invoiceTable .wasteForm table tbody tr {
  border-color: #2d53a1;
  text-align: center;
}
.invoices .invoiceTable .wasteForm table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.invoices .invoiceTable .wasteForm table tbody tr td input[type=number] {
  width: 40%;
}
.invoices .invoiceTable .wasteForm button {
  margin-top: 2vh;
  margin-bottom: 2vh;
  width: 50vw;
}
@media (max-width: 600px) {
  .invoices .invoiceTable .wasteForm {
    width: 100%;
  }
  .invoices .invoiceTable .wasteForm table {
    width: 95%;
    margin: 2% auto;
    font-size: 0.8rem;
    word-break: break-all;
  }
  .invoices .invoiceTable .wasteForm table tbody tr td input {
    width: 50%;
  }
  .invoices .invoiceTable .wasteForm table tbody tr td input[type=file] {
    width: 100%;
    font-size: 0.36rem;
  }
  .invoices .invoiceTable .wasteForm table tbody tr td select {
    width: 70%;
  }
}
@media (min-width: 601px) and (max-width: 900px) {
  .invoices .invoiceTable .wasteForm {
    width: 100%;
  }
  .invoices .invoiceTable .wasteForm table {
    width: 90%;
    margin: 2% auto;
    font-size: 0.9rem;
    word-break: break-all;
  }
  .invoices .invoiceTable .wasteForm table tbody tr td select {
    width: 90%;
  }
}
.invoices .invoiceTable .wasteForm .mobile__box {
  width: 90%;
  background-color: #fff;
  margin: 3% auto;
  border-radius: 1rem;
  min-height: 25vh;
  color: #4d4d4d;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_head {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column-reverse;
  border-bottom: 2px solid #2c53a0;
  padding-bottom: 2%;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_head h6 {
  background-color: #f2f2f2;
  padding: 2%;
  border-radius: 0.5rem;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  width: 75%;
  text-align: center;
  margin-bottom: 0;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 95%;
  margin: 5% auto;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_body .item_body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background-color: #f2f2f2;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  padding: 1%;
  border-radius: 0.5rem;
  width: 60%;
  text-align: center;
  margin: 2% auto;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_body .item_body p {
  margin: 0;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_body .item_body p span {
  color: #2c53a0;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_body .body_right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_body .body_right select {
  border: 1px solid #64c4e0;
  margin: 1% auto;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_body .body_right input[type=file] {
  width: 45.1%;
  margin: 1% auto;
}
.invoices .invoiceTable .wasteForm .mobile__box .mobile_box_body input[type=number] {
  width: 20%;
  border: 1px solid #64c4e0;
}

.modalTable {
  width: 80%;
  margin: auto;
}
.modalTable thead tr {
  background-color: #2d53a1;
  color: #fcfcfc;
}
.modalTable tbody tr {
  border-color: #2d53a1;
}
.modalTable tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}

.modal__table__wastage {
  width: 90%;
  margin: auto;
  text-align: center;
}
.modal__table__wastage thead tr {
  background-color: #fff;
  border-bottom: 1px solid #4d4d4d;
}
.modal__table__wastage tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}

#yes__btn {
  background-color: #fff;
  border: 1px solid #00c446;
  color: #00c446;
  border-radius: 0.25rem;
  height: 2rem;
}

#no__btn {
  background-color: #fff;
  border: 1px solid #bb0000;
  color: #bb0000;
  border-radius: 0.25rem;
  height: 2rem;
}

.claims__modal__all {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.claims__modal__all .claims__modal {
  width: 95%;
  color: #4d4d4d;
  margin: auto;
  text-align: center;
  table-layout: fixed;
  border-collapse: collapse;
}
.claims__modal__all .claims__modal thead {
  border-bottom: 1px solid #2c53a0;
}
.claims__modal__all .claims__modal tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.claims__modal__all .claims__modal tbody tr select,
.claims__modal__all .claims__modal tbody tr input {
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
.claims__modal__all .claims__modal tbody tr input {
  width: 50%;
}
@media (max-width: 600px) {
  .claims__modal__all .claims__modal {
    width: 100%;
    font-size: 0.9rem;
  }
  .claims__modal__all .claims__modal tbody tr input,
  .claims__modal__all .claims__modal tbody tr select {
    width: 70%;
  }
}

/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@keyframes upDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}
.checker_main {
  min-height: 74vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: #4d4d4d;
}
.checker_main .site_select {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.checker_main .site_select select {
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
.checker_main .invoice_header {
  background-color: #fff;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
  width: 70vw;
  margin: 1% auto;
  position: relative;
}
.checker_main .invoice_header .header2 {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.checker_main .invoice_header .header2 h2 span {
  color: #2c53a0;
}
.checker_main .invoice_header .icon {
  position: absolute;
  bottom: 2%;
  right: 2%;
  animation: upDown 1.5s infinite;
  -webkit-animation: upDown 1.5s infinite;
}
.checker_main .invoice_header .invoice2 {
  width: 95%;
  margin: 1% auto;
}
.checker_main .invoice_header .invoice2 table {
  width: 100%;
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
}
.checker_main .invoice_header .invoice2 table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.checker_main .invoice_header .invoice2 table tbody {
  text-align: center;
}
.checker_main .invoice_header .invoice2 table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.checker_main .invoice_header .invoice2 table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.checker_main .invoice_header .invoice2 table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}

.invoice_main {
  min-height: 74vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: #4d4d4d;
}
.invoice_main button {
  background-color: #0095ff;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: rgba(255, 255, 255, 0.4) 0 1px 0 0 inset;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, system-ui, "Segoe UI", "Liberation Sans", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.15385;
  margin: 0;
  outline: none;
  padding: 8px 0.8em;
  position: relative;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  white-space: nowrap;
}
.invoice_main button:hover, .invoice_main button:focus {
  background-color: #07c;
}
.invoice_main button:focus {
  box-shadow: 0 0 0 4px rgba(0, 149, 255, 0.15);
}
.invoice_main button:active {
  background-color: #0064bd;
  box-shadow: none;
}
.invoice_main .loader_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.invoice_main .loader_container .loader_circles {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5% auto;
  --color: hsl(0, 1%, 42%);
  --animation: 2s ease-in-out infinite;
}
.invoice_main .loader_container .loader_circles .circle {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 20px;
  height: 20px;
  border: solid 2px var(--color);
  border-radius: 50%;
  margin: 0 10px;
  background-color: transparent;
  animation: circle-keys var(--animation);
}
.invoice_main .loader_container .loader_circles .circle .dot {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--color);
  animation: dot-keys var(--animation);
}
.invoice_main .loader_container .loader_circles .circle .outline {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  animation: outline-keys var(--animation);
}
.invoice_main .loader_container .loader_circles .circle:nth-child(1) .outline {
  animation-delay: 0.9s;
}
.invoice_main .loader_container .loader_circles .circle:nth-child(2) {
  animation-delay: 0.3s;
}
.invoice_main .loader_container .loader_circles .circle:nth-child(2) .dot {
  animation-delay: 0.3s;
}
.invoice_main .loader_container .loader_circles .circle:nth-child(2) .outline {
  animation-delay: 1.2s;
}
.invoice_main .loader_container .loader_circles .circle:nth-child(3) {
  animation-delay: 0.6s;
}
.invoice_main .loader_container .loader_circles .circle:nth-child(3) .dot {
  animation-delay: 0.6s;
}
.invoice_main .loader_container .loader_circles .circle:nth-child(3) .outline {
  animation-delay: 1.5s;
}

@keyframes circle-keys {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes dot-keys {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes outline-keys {
  0% {
    transform: scale(0);
    outline: solid 20px var(--color);
    outline-offset: 0;
    opacity: 1;
  }
  100% {
    transform: scale(1);
    outline: solid 0 transparent;
    outline-offset: 20px;
    opacity: 0;
  }
}
@media (max-width: 600px) {
  .invoices h1 {
    font-size: 1.5rem;
  }
  .invoices .invoiceTable #invoices {
    font-size: 0.9rem;
  }
  .invoices .invoiceTable #invoices .invoiceData {
    text-align: right;
  }
  .invoices thead,
  .invoices tbody,
  .invoices th,
  .invoices td,
  .invoices tr {
    display: block;
    text-align: right;
  }
  .invoices thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .invoices tr {
    border: 1px solid #ccc;
    margin-bottom: 20px;
  }
  .invoices td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    align-items: center;
    padding-right: 5px;
  }
  .invoices td:before {
    position: absolute;
    top: 3px;
    left: 10px;
    font-weight: 700;
  }
  .invoices td:nth-of-type(1):before {
    content: "";
  }
  .invoices td:nth-of-type(2):before {
    content: "Invoice No. -";
  }
  .invoices td:nth-of-type(3):before {
    content: "Date -";
  }
  .invoices td:nth-of-type(4):before {
    content: "Items -";
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/StoreZone/styles/invoices.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAEA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAAJ;AAEI;EACI,cAAA;EACA,kBAAA;AAAR;AAGI;EACI,aAAA;EACA,8BAAA;AADR;AAGQ;EACI,gBAAA;EACA,WAAA;AADZ;AAIQ;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;AAFZ;AAMI;EACI,gBAAA;AAJR;AAMQ;EACI,UAAA;EACA,YAAA;AAJZ;AAKY;EACI,kBAAA;AAHhB;AAOQ;EACI,yBAAA;EACA,cAAA;AALZ;AAQQ;EACI,yBAAA;EACA,cAAA;EACA,qBAAA;AANZ;AASQ;EACI,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AAPZ;AASY;EACI,WAAA;EACA,eAAA;EACA,mBAAA;AAPhB;AAUoB;EACI,yBAAA;EACA,cAAA;AARxB;AAYgB;EACI,sBAAA;AAVpB;AAYoB;EACI,qBAAA;EACA,kBAAA;AAVxB;AAYwB;EACI,yBAAA;AAV5B;AAc4B;EACI,UAAA;AAZhC;AAmBY;EACI,eAAA;EACA,kBAAA;EACA,WAAA;AAjBhB;AAoBY;EA9CJ;IA+CQ,WAAA;EAjBd;EAmBc;IACI,UAAA;IACA,eAAA;IACA,iBAAA;IACA,qBAAA;EAjBlB;EAsB8B;IACI,UAAA;EApBlC;EAuB8B;IACI,WAAA;IACA,kBAAA;EArBlC;EAwB8B;IACI,UAAA;EAtBlC;AACF;AA6BY;EA5EJ;IA6EQ,WAAA;EA1Bd;EA4Bc;IACI,UAAA;IACA,eAAA;IACA,iBAAA;IACA,qBAAA;EA1BlB;EA+B8B;IACI,UAAA;EA7BlC;AACF;AAoCY;EACI,UAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cD5JJ;EAyBR,0CAAA;ACkGJ;AAoCgB;ED9FZ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EC6FgB,8BAAA;EAIA,gCAAA;EACA,kBAAA;AAlCpB;AAoCoB;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;EDlJpB,0CAAA;ECoJoB,UAAA;EACA,kBAAA;EACA,gBAAA;AAlCxB;AAsCgB;EDlHZ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECiHgB,UAAA;EACA,eAAA;AAjCpB;AAmCoB;EDjHhB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ECgHoB,yBAAA;EDjKpB,0CAAA;ECmKoB,WAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AA9BxB;AAgCwB;EACI,SAAA;AA9B5B;AAgC4B;EACI,cDzMpB;AC2KZ;AAmCoB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAjCxB;AAmCwB;EACI,yBAAA;EACA,eAAA;AAjC5B;AAoCwB;EACI,YAAA;EACA,eAAA;AAlC5B;AAsCoB;EACI,UAAA;EACA,yBAAA;AApCxB;;AA4CA;EACI,UAAA;EACA,YAAA;AAzCJ;AA4CQ;EACI,yBAAA;EACA,cAAA;AA1CZ;AA+CQ;EACI,qBAAA;AA7CZ;AA+CY;EACI,yBAAA;AA7ChB;;AAmDA;EACI,UAAA;EACA,YAAA;EACA,kBAAA;AAhDJ;AAmDQ;EACI,sBAAA;EACA,gCAAA;AAjDZ;AAuDY;EACI,yBAAA;AArDhB;;AA2DA;EACI,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;AAxDJ;;AA2DA;EACI,sBAAA;EACA,yBAAA;EACA,cD3RI;EC4RJ,sBAAA;EACA,YAAA;AAxDJ;;AA2DA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAxDJ;AA0DI;EACI,UAAA;EACA,cDxSI;ECySJ,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAxDR;AA0DQ;EACI,gCAAA;AAxDZ;AA6DgB;EACI,yBAAA;AA3DpB;AA8DgB;;EAEI,yBAAA;EACA,qBAAA;AA5DpB;AA+DgB;EACI,UAAA;AA7DpB;AAkEQ;EA9BJ;IA+BQ,WAAA;IACA,iBAAA;EA/DV;EAmEkB;;IAEI,UAAA;EAjEtB;AACF;;ADxQA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;AC6PJ;AAoEA;EACI;IACI,wBAAA;EAlEN;EAqEE;IACI,2BAAA;EAnEN;EAsEE;IACI,wBAAA;EApEN;AACF;AAuEA;EACI,gBAAA;EDpSA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECmSA,cDvWQ;ACqSZ;AAoEI;ED3OA,aAAA;EACA,mBAAA;EACA,2BAAA;AC0KJ;AAkEQ;EACI,yBAAA;EACA,qBAAA;AAhEZ;AAoEI;EDrVA,sBAAA;EAJA,0CAAA;EAMA,mBAAA;ECqVI,WAAA;EACA,eAAA;EACA,kBAAA;AAhER;AAkEQ;EDnSJ,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;ACoOJ;AAgEgB;EACI,cDhYR;ACkUZ;AAmEQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,+BAAA;EACA,uCAAA;AAjEZ;AAoEQ;EACI,UAAA;EACA,eAAA;AAlEZ;AAoEY;EACI,WAAA;ED3QZ,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ACiVZ;ADzMI;EACI,gCAAA;EACA,kBAAA;AC2MR;ADzMI;EACI,kBAAA;AC2MR;AD1MQ;EACI,gCAAA;AC4MZ;AD3MY;EACI,yBAAA;AC6MhB;AD3MY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AC6MhB;;AAmDA;EACI,gBAAA;EDtVA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECqVA,cDzZQ;AC4WZ;AA+CI;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oDAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,gFAAA;EAEA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,mBAAA;AA9CR;AAgDQ;EAEI,sBAAA;AA/CZ;AAkDQ;EACI,6CAAA;AAhDZ;AAmDQ;EACI,yBAAA;EACA,gBAAA;AAjDZ;AAqDI;EDnYA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ACiVJ;AAkDQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,oCAAA;AAhDZ;AAkDY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,uCAAA;AAhDhB;AAkDgB;EACI,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,oCAAA;AAhDpB;AAmDgB;EACI,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;AAjDpB;AAqDoB;EACI,qBAAA;AAnDxB;AAuDgB;EACI,qBAAA;AArDpB;AAuDoB;EACI,qBAAA;AArDxB;AAwDoB;EACI,qBAAA;AAtDxB;AA0DgB;EACI,qBAAA;AAxDpB;AA0DoB;EACI,qBAAA;AAxDxB;AA2DoB;EACI,qBAAA;AAzDxB;;AAoFA;EACI;IACI,mBAAA;IACA,UAAA;EAjFN;EAoFE;IACI,qBAAA;IACA,YAAA;EAlFN;EAqFE;IACI,mBAAA;IACA,UAAA;EAnFN;AACF;AAsFA;EACI;IACI,mBAAA;EApFN;EAuFE;IACI,mBAAA;EArFN;EAwFE;IACI,mBAAA;EAtFN;AACF;AAyFA;EACI;IACI,mBAAA;IACA,gCAAA;IACA,iBAAA;IACA,UAAA;EAvFN;EA0FE;IACI,mBAAA;IACA,4BAAA;IACA,oBAAA;IACA,UAAA;EAxFN;AACF;AA2FA;EAEQ;IACI,iBAAA;EA1FV;EA8FU;IACI,iBAAA;EA5Fd;EA6Fc;IACI,iBAAA;EA3FlB;EAgGM;;;;;IAKI,cAAA;IACA,iBAAA;EA9FV;EAiGM;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EA/FV;EAkGM;IACI,sBAAA;IACA,mBAAA;EAhGV;EAmGM;IACI,yBAAA;IACA,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;EAjGV;EAoGM;IACI,kBAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;EAlGV;EAqGM;IACI,WAAA;EAnGV;EAsGM;IACI,wBAAA;EApGV;EAuGM;IACI,iBAAA;EArGV;EAwGM;IACI,kBAAA;EAtGV;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n// ::-webkit-scrollbar {\n//     display: none;\n// }\n\n.invoices {\n    width: 100%;\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n    justify-items: center;\n\n    h1 {\n        color: #4d4d4d;\n        text-align: center;\n    }\n\n    .invoicesHeader {\n        display: flex;\n        justify-content: space-between;\n\n        .manualEdn {\n            margin-left: 10%;\n            height: 15%;\n        }\n\n        .update {\n            color: #4d4d4d;\n            text-align: right;\n            margin-right: 10%;\n        }\n    }\n\n    .invoiceTable {\n        min-height: 73vh;\n\n        #invoices {\n            width: 80%;\n            margin: auto;\n            .invoiceData {\n                text-align: center;\n            }\n        }\n\n        table th {\n            background-color: #2d53a1;\n            color: #fcfcfc;\n        }\n\n        table tr {\n            background-color: #fcfcfc;\n            color: #2d53a1;\n            border-color: #2d53a1;\n        }\n\n        .wasteForm {\n            display: flex;\n            flex-direction: column;\n            justify-items: flex-start;\n            align-items: center;\n            width: 80%;\n            margin: auto;\n\n            table {\n                width: 100%;\n                margin: 2% auto;\n                table-layout: fixed;\n\n                thead {\n                    tr {\n                        background-color: #2d53a1;\n                        color: #fcfcfc;\n                    }\n                }\n\n                tbody {\n                    background-color: #fff;\n\n                    tr {\n                        border-color: #2d53a1;\n                        text-align: center;\n\n                        &:nth-child(odd) {\n                            background-color: #f2f2f2;\n                        }\n\n                        td {\n                            input[type=\"number\"] {\n                                width: 40%;\n                            }\n                        }\n                    }\n                }\n            }\n\n            button {\n                margin-top: 2vh;\n                margin-bottom: 2vh;\n                width: 50vw;\n            }\n\n            @media (max-width: $mobile) {\n                width: 100%;\n\n                table {\n                    width: 95%;\n                    margin: 2% auto;\n                    font-size: 0.8rem;\n                    word-break: break-all;\n\n                    tbody {\n                        tr {\n                            td {\n                                input {\n                                    width: 50%;\n                                }\n\n                                input[type=\"file\"] {\n                                    width: 100%;\n                                    font-size: 0.36rem;\n                                }\n\n                                select {\n                                    width: 70%;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            @media (min-width: 601px) and (max-width: 900px) {\n                width: 100%;\n\n                table {\n                    width: 90%;\n                    margin: 2% auto;\n                    font-size: 0.9rem;\n                    word-break: break-all;\n\n                    tbody {\n                        tr {\n                            td {\n                                select {\n                                    width: 90%;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            .mobile__box {\n                width: 90%;\n                background-color: #fff;\n                margin: 3% auto;\n                border-radius: 1rem;\n                min-height: 25vh;\n                color: $fontColor;\n                @include shadow;\n\n                .mobile_box_head {\n                    @include columnStart;\n                    flex-direction: column-reverse;\n                    // display: flex;\n                    // align-items: center;\n                    // justify-content: space-around;\n                    border-bottom: 2px solid $nitroDark;\n                    padding-bottom: 2%;\n\n                    h6 {\n                        background-color: #f2f2f2;\n                        padding: 2%;\n                        border-radius: 0.5rem;\n                        @include shadow;\n                        width: 75%;\n                        text-align: center;\n                        margin-bottom: 0;\n                    }\n                }\n\n                .mobile_box_body {\n                    @include columnStart;\n                    width: 95%;\n                    margin: 5% auto;\n\n                    .item_body {\n                        @include columnAlignStart;\n                        background-color: #f2f2f2;\n                        @include shadow;\n                        padding: 1%;\n                        border-radius: 0.5rem;\n                        width: 60%;\n                        text-align: center;\n                        margin: 2% auto;\n\n                        p {\n                            margin: 0;\n\n                            span {\n                                color: $nitroDark;\n                            }\n                        }\n                    }\n\n                    .body_right {\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n                        justify-content: center;\n\n                        select {\n                            border: 1px solid $nitroLight;\n                            margin: 1% auto;\n                        }\n\n                        input[type=\"file\"] {\n                            width: 45.1%;\n                            margin: 1% auto;\n                        }\n                    }\n\n                    input[type=\"number\"] {\n                        width: 20%;\n                        border: 1px solid $nitroLight;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.modalTable {\n    width: 80%;\n    margin: auto;\n\n    thead {\n        tr {\n            background-color: #2d53a1;\n            color: #fcfcfc;\n        }\n    }\n\n    tbody {\n        tr {\n            border-color: #2d53a1;\n\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n        }\n    }\n}\n\n.modal__table__wastage {\n    width: 90%;\n    margin: auto;\n    text-align: center;\n\n    thead {\n        tr {\n            background-color: #fff;\n            border-bottom: 1px solid $fontColor;\n        }\n    }\n\n    tbody {\n        tr {\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n        }\n    }\n}\n\n#yes__btn {\n    background-color: #fff;\n    border: 1px solid #00c446;\n    color: #00c446;\n    border-radius: 0.25rem;\n    height: 2rem;\n}\n\n#no__btn {\n    background-color: #fff;\n    border: 1px solid $error;\n    color: $error;\n    border-radius: 0.25rem;\n    height: 2rem;\n}\n\n.claims__modal__all {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .claims__modal {\n        width: 95%;\n        color: $fontColor;\n        margin: auto;\n        text-align: center;\n        table-layout: fixed;\n        border-collapse: collapse;\n\n        thead {\n            border-bottom: 1px solid $nitroDark;\n        }\n\n        tbody {\n            tr {\n                &:nth-child(odd) {\n                    background-color: #f2f2f2;\n                }\n\n                select,\n                input {\n                    border: 1px solid $nitroDark;\n                    border-radius: 0.5rem;\n                }\n\n                input {\n                    width: 50%;\n                }\n            }\n        }\n\n        @media (max-width: $mobile) {\n            width: 100%;\n            font-size: 0.9rem;\n\n            tbody {\n                tr {\n                    input,\n                    select {\n                        width: 70%;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@import \"../../variables.scss\";\n\n@keyframes upDown {\n    0% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-5px);\n    }\n\n    100% {\n        transform: translateY(0);\n    }\n}\n\n.checker_main {\n    min-height: 74vh;\n    @include columnStart;\n    color: $fontColor;\n\n    .site_select {\n        @include rowStart;\n\n        select {\n            border: 1px solid $nitroDark;\n            border-radius: 0.5rem;\n        }\n    }\n\n    .invoice_header {\n        @include card;\n        width: 70vw;\n        margin: 1% auto;\n        position: relative;\n\n        .header2 {\n            @include rowEven;\n\n            h2 {\n                span {\n                    color: $nitroDark;\n                }\n            }\n        }\n\n        .icon {\n            position: absolute;\n            bottom: 2%;\n            right: 2%;\n            animation: upDown 1.5s infinite;\n            -webkit-animation: upDown 1.5s infinite;\n        }\n\n        .invoice2 {\n            width: 95%;\n            margin: 1% auto;\n\n            table {\n                width: 100%;\n                @include table;\n            }\n        }\n    }\n}\n\n.invoice_main {\n    min-height: 74vh;\n    @include columnStart;\n    color: $fontColor;\n\n    button {\n        background-color: #0095ff;\n        border: 1px solid transparent;\n        border-radius: 3px;\n        box-shadow: rgba(255, 255, 255, 0.4) 0 1px 0 0 inset;\n        box-sizing: border-box;\n        color: #fff;\n        cursor: pointer;\n        display: inline-block;\n        font-family: -apple-system, system-ui, \"Segoe UI\", \"Liberation Sans\",\n            sans-serif;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 1.15385;\n        margin: 0;\n        outline: none;\n        padding: 8px 0.8em;\n        position: relative;\n        text-align: center;\n        text-decoration: none;\n        user-select: none;\n        -webkit-user-select: none;\n        touch-action: manipulation;\n        vertical-align: baseline;\n        white-space: nowrap;\n\n        &:hover,\n        &:focus {\n            background-color: #07c;\n        }\n\n        &:focus {\n            box-shadow: 0 0 0 4px rgba(0, 149, 255, 0.15);\n        }\n\n        &:active {\n            background-color: #0064bd;\n            box-shadow: none;\n        }\n    }\n\n    .loader_container {\n        @include columnStart;\n\n        .loader_circles {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin: 5% auto;\n            --color: hsl(0, 1%, 42%);\n            --animation: 2s ease-in-out infinite;\n\n            .circle {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                position: relative;\n                width: 20px;\n                height: 20px;\n                border: solid 2px var(--color);\n                border-radius: 50%;\n                margin: 0 10px;\n                background-color: transparent;\n                animation: circle-keys var(--animation);\n\n                .dot {\n                    position: absolute;\n                    transform: translate(-50%, -50%);\n                    width: 16px;\n                    height: 16px;\n                    border-radius: 50%;\n                    background-color: var(--color);\n                    animation: dot-keys var(--animation);\n                }\n\n                .outline {\n                    position: absolute;\n                    transform: translate(-50%, -50%);\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    animation: outline-keys var(--animation);\n                }\n\n                &:nth-child(1) {\n                    .outline {\n                        animation-delay: 0.9s;\n                    }\n                }\n\n                &:nth-child(2) {\n                    animation-delay: 0.3s;\n\n                    .dot {\n                        animation-delay: 0.3s;\n                    }\n\n                    .outline {\n                        animation-delay: 1.2s;\n                    }\n                }\n\n                &:nth-child(3) {\n                    animation-delay: 0.6s;\n\n                    .dot {\n                        animation-delay: 0.6s;\n                    }\n\n                    .outline {\n                        animation-delay: 1.5s;\n                    }\n                }\n\n                // &:nth-child(4) {\n                //   animation-delay: 0.9s;\n                //   .dot {\n                //     animation-delay: 0.9s;\n                //   }\n                //   .outline {\n                //     animation-delay: 1.8s;\n                //   }\n                // }\n                // &:nth-child(5) {\n                //   animation-delay: 1.2s;\n                //   .dot {\n                //     animation-delay: 1.2s;\n                //   }\n                //   .outline {\n                //     animation-delay: 2.1s;\n                //   }\n                // }\n            }\n        }\n    }\n}\n\n@keyframes circle-keys {\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n\n    50% {\n        transform: scale(1.5);\n        opacity: 0.5;\n    }\n\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n@keyframes dot-keys {\n    0% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(0);\n    }\n\n    100% {\n        transform: scale(1);\n    }\n}\n\n@keyframes outline-keys {\n    0% {\n        transform: scale(0);\n        outline: solid 20px var(--color);\n        outline-offset: 0;\n        opacity: 1;\n    }\n\n    100% {\n        transform: scale(1);\n        outline: solid 0 transparent;\n        outline-offset: 20px;\n        opacity: 0;\n    }\n}\n\n@media (max-width: $mobile) {\n    .invoices {\n        h1 {\n            font-size: 1.5rem;\n        }\n\n        .invoiceTable {\n            #invoices {\n                font-size: 0.9rem;\n                .invoiceData {\n                    text-align: right;\n                }\n            }\n        }\n\n        thead,\n        tbody,\n        th,\n        td,\n        tr {\n            display: block;\n            text-align: right;\n        }\n\n        thead tr {\n            position: absolute;\n            top: -9999px;\n            left: -9999px;\n        }\n\n        tr {\n            border: 1px solid #ccc;\n            margin-bottom: 20px;\n        }\n\n        td {\n            /* Behave  like a \"row\" */\n            border: none;\n            border-bottom: 1px solid #eee;\n            position: relative;\n            align-items: center;\n            padding-right: 5px;\n        }\n\n        td:before {\n            position: absolute;\n            top: 3px;\n            left: 10px;\n            font-weight: 700;\n        }\n\n        td:nth-of-type(1):before {\n            content: \"\";\n        }\n\n        td:nth-of-type(2):before {\n            content: \"Invoice No. -\";\n        }\n\n        td:nth-of-type(3):before {\n            content: \"Date -\";\n        }\n\n        td:nth-of-type(4):before {\n            content: \"Items -\";\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
